module.exports = __webpack_public_path__ + "img/first-birthday-min.bd9492c7.png";